import React from 'react';
import {useTranslation} from 'react-i18next';
import styles from './VolumeCommand.module.css';
import {formatNumber} from '../../../assets/utils/utils';
import {StatsElement} from '../../../types/MyDynamicsData';

type Props = {
	selectedStatElement: StatsElement | null;
};

const ChartIndicators: React.FC<Props> = ({selectedStatElement}) => {
	const {t} = useTranslation();

	return (
		<div className={styles.chartIndicators}>
			<div className={styles.chartIndicator}>
				{t('Середній показник за день')}
			</div>
			{selectedStatElement && (
				<div className={styles.chartPoint}>
					<div className={styles.chartPointValue}>
						{formatNumber(selectedStatElement.nowm_money_avg)} грн
					</div>
					<div className={styles.chartPointValue}>
						{formatNumber(selectedStatElement.nowm_points_avg)}{' '}
						<span>{t('Бали')}</span>
					</div>
				</div>
			)}
		</div>
	);
};

export default ChartIndicators;
